export default "__VITE_ASSET__504cbdcc__"